/* section-header.js — extracted from sections/header.liquid */
function focusHeaderSearch(e) {
    if (e) e.preventDefault();
    const headerWrapper = document.getElementById('site-header-wrapper');
    if (headerWrapper) {
      const isOpen = headerWrapper.classList.toggle('search-open');
      if (isOpen) {
        const searchInput = headerWrapper.querySelector('.header-search-input');
        if (searchInput) {
          setTimeout(() => searchInput.focus(), 50);
        }
      }
    }
  }

  function toggleMobileSearch(e) {
    if (e) e.preventDefault();
    const headerWrapper = document.getElementById('site-header-wrapper');
    if (headerWrapper) {
      headerWrapper.classList.toggle('mobile-search-open');
      const searchInput = headerWrapper.querySelector('.header-search-input');
      if (headerWrapper.classList.contains('mobile-search-open')) {
        if (searchInput) {
          setTimeout(() => searchInput.focus(), 80);
        }
      }
      if (typeof syncHeaderHeight === 'function') {
        syncHeaderHeight();
      }
    }
  }

  const __initSectionHeader1 = () => {
    const headerWrapper = document.getElementById('site-header-wrapper');

    // 0. Dynamic Header Height Sync for perfect overlay without gaps
    const syncHeaderHeight = () => {
      if (headerWrapper && !headerWrapper.classList.contains('is-scrolled')) {
        const height = headerWrapper.getBoundingClientRect().height;
        if (height > 30) {
          document.documentElement.style.setProperty('--header-actual-height', height + 'px');
        }
      }
    };
    syncHeaderHeight();
    window.addEventListener('resize', syncHeaderHeight);
    window.addEventListener('load', syncHeaderHeight);

    // Search focus & click-outside / escape handling on desktop sticky header
    if (headerWrapper) {
      document.addEventListener('click', (evt) => {
        if (headerWrapper.classList.contains('search-open')) {
          if (!headerWrapper.contains(evt.target)) {
            headerWrapper.classList.remove('search-open');
          }
        }
      });

      document.addEventListener('keydown', (evt) => {
        if (evt.key === 'Escape') {
          headerWrapper.classList.remove('search-open');
          headerWrapper.classList.remove('mobile-search-open');
        }
      });
    }

    // 1. Sticky Header Scroll Effect with Hysteresis (Zero Snapping)
    if (headerWrapper) {
      let isScrolled = false;
      let ticking = false;

      const updateStickyState = () => {
        const scrollY = window.scrollY || window.pageYOffset || 0;
        if (!isScrolled && scrollY > 60) {
          isScrolled = true;
          headerWrapper.classList.add('is-scrolled');
        } else if (isScrolled && scrollY < 20) {
          isScrolled = false;
          headerWrapper.classList.remove('is-scrolled');
        }
        ticking = false;
      };

      const handleScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(updateStickyState);
          ticking = true;
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      updateStickyState();
    }

    // 2. Animated Placeholder Cycling ("Try searching for.. <collection names>")
    const searchInput = document.querySelector('.header-search-input');
    if (searchInput) {
      const rawSuggestions = searchInput.getAttribute('data-suggestions') || 'Corset Tops, Mini Dresses, Satin Gowns, Occasionwear, New In, Swimwear';
      const items = rawSuggestions.split(',').map(s => s.trim()).filter(Boolean);

      if (items.length > 0) {
        let currentIndex = 0;
        setInterval(() => {
          if (document.activeElement !== searchInput) {
            currentIndex = (currentIndex + 1) % items.length;
            searchInput.setAttribute('placeholder', `Try searching for.. ${items[currentIndex]}`);
          }
        }, 3000);
      }
    }
  }
  document.addEventListener('DOMContentLoaded', __initSectionHeader1);
  document.addEventListener('shopify:section:load', __initSectionHeader1);
  if (document.readyState !== 'loading') __initSectionHeader1();

(function () {
    function initPredictiveSearch() {
      var form = document.querySelector('[data-predictive-search-form]');
      if (!form || form.dataset.predictiveBound === 'true') return;
      form.dataset.predictiveBound = 'true';

      var input = form.querySelector('[data-predictive-input]');
      var panel = form.querySelector('[data-predictive-search]');
      if (!input || !panel) return;

      var results = panel.querySelector('[data-predictive-results]');
      var loading = panel.querySelector('[data-predictive-loading]');
      var liveRegion = form.querySelector('[data-predictive-live-region]');
      var controller = null;
      var timer = null;

      function hide() {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      }

      function show() {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      function search(term) {
        if (controller) controller.abort();
        controller = new AbortController();
        if (loading) loading.hidden = false;

        var url =
          window.themeRoutes.predictiveSearch +
          '?q=' + encodeURIComponent(term) +
          '&resources[type]=product,collection,page,article' +
          '&resources[limit]=6' +
          '&section_id=predictive-search';

        fetch(url, { signal: controller.signal })
          .then(function (response) {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var fragment = doc.querySelector('#shopify-section-predictive-search') || doc.body;
            results.innerHTML = fragment.innerHTML;
            if (loading) loading.hidden = true;
            show();
            if (liveRegion) {
              liveRegion.textContent = results.querySelectorAll('[data-predictive-item]').length
                ? window.themeStrings.searchResultsAvailable
                : window.themeStrings.searchNoResults;
            }
          })
          .catch(function (error) {
            if (error.name === 'AbortError') return;
            if (loading) loading.hidden = true;
            hide();
          });
      }

      input.addEventListener('input', function () {
        var term = input.value.trim();
        clearTimeout(timer);
        if (term.length < 2) {
          hide();
          return;
        }
        timer = setTimeout(function () {
          search(term);
        }, 250);
      });

      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2 && results.innerHTML.trim()) show();
      });

      document.addEventListener('click', function (event) {
        if (!form.contains(event.target)) hide();
      });

      form.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          hide();
          input.focus();
        }
      });
    }

    document.addEventListener('DOMContentLoaded', initPredictiveSearch);
    document.addEventListener('shopify:section:load', initPredictiveSearch);
    initPredictiveSearch();
  })();

/**
 * Nested header navigation.
 *
 * Opening and closing is handled in CSS (:hover and :focus-within) so the menu
 * works without this file. All this adds is the part CSS cannot do: keeping
 * aria-expanded truthful for screen readers, and closing on Escape.
 */
(function () {
  'use strict';

  function setExpanded(item, open) {
    var trigger = item.querySelector('.quick-nav-link');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initHeaderNavDropdowns() {
    var items = document.querySelectorAll('.quick-nav-item.has-dropdown');

    items.forEach(function (item) {
      if (item.dataset.navDropdownBound === 'true') return;
      item.dataset.navDropdownBound = 'true';

      item.addEventListener('mouseenter', function () { setExpanded(item, true); });
      item.addEventListener('mouseleave', function () { setExpanded(item, false); });
      item.addEventListener('focusin', function () { setExpanded(item, true); });

      // focusout fires before focus lands, so check where it is going rather
      // than closing on every tab between links inside the same panel.
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) setExpanded(item, false);
      });

      item.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var trigger = item.querySelector('.quick-nav-link');
        // Dropping focus out of the item closes the :focus-within panel.
        if (document.activeElement) document.activeElement.blur();
        setExpanded(item, false);
        if (trigger) trigger.focus();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initHeaderNavDropdowns);
  document.addEventListener('shopify:section:load', initHeaderNavDropdowns);
  if (document.readyState !== 'loading') initHeaderNavDropdowns();
})();


/**
 * Labelled header menus.
 *
 * These are <details>/<summary>, so the click toggle, keyboard handling and
 * expanded state are native and work without this file. What <details> does
 * not do on its own is close when you click elsewhere, close on Escape, or
 * close a sibling when another opens - that is all this adds.
 */
(function () {
  'use strict';

  function openMenus(except) {
    var open = [];
    document.querySelectorAll('.quick-nav-item.is-toggle .quick-nav-details[open]')
      .forEach(function (el) { if (el !== except) open.push(el); });
    return open;
  }

  function closeAll(except) {
    openMenus(except).forEach(function (el) { el.removeAttribute('open'); });
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('.quick-nav-link--trigger');

    if (summary) {
      // The click that opens this one closes any other. Every other panel's
      // state is already settled, so this needs no deferral - going through
      // requestAnimationFrame left siblings open in a backgrounded tab, where
      // the callback is throttled or never runs.
      closeAll(summary.closest('.quick-nav-details'));
      return;
    }

    if (!event.target.closest || !event.target.closest('.quick-nav-details')) closeAll(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var open = openMenus(null);
    if (!open.length) return;

    // Return focus to the control that opened the panel, rather than dropping
    // it to the top of the document.
    var active = document.activeElement;
    var current = active && active.closest ? active.closest('.quick-nav-details') : null;

    closeAll(null);

    var target = current || open[0];
    var summary = target.querySelector('.quick-nav-link--trigger');
    if (summary) summary.focus();
  });
})();
